export default {
    bindings: {
        short: '<',
        event: '<',
        header: '<'
    },
    controller: 'membershipBannerController',
    template: require('../views/membershipBanner.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/components/membershipBanner.component.js